import script from "./TrialsGoals.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrialsGoals.vue?vue&type=script&setup=true&lang=ts"

import "./TrialsGoals.vue?vue&type=style&index=0&id=a1d03aec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1d03aec"]])

export default __exports__